import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { ThemeProvider } from 'contexts/ThemeProvider';

import { pageview } from 'utils/gtag';

import type { AppProps } from 'next/app';

import 'assets/fonts/font-styles.css';
import 'slick-carousel/slick/slick.css';

const MyApp = ({ Component, pageProps }: AppProps) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      if (router.isReady) {
        pageview(router.asPath, document.title);
      }
    };
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.asPath]);

  return (
    <ThemeProvider>
      <Component {...pageProps} />
    </ThemeProvider>
  );
};

export default MyApp;
